import React from "react";
import AdminCrud from "@/components/AdminCrud";

function fmt(d) {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("pt-BR"); } catch { return d; }
}

export default function AdminEvents() {
  return (
    <AdminCrud
      title="Eventos"
      resource="events"
      initialItem={{ status: "published" }}
      fields={[
        { name: "name", label: "Nome do evento", required: true },
        { name: "start_date", label: "Data de início", type: "date", required: true, help: "Data em que o evento começa." },
        { name: "end_date", label: "Data de fim (opcional)", type: "date", help: "Deixe em branco se for evento de um único dia." },
        { name: "time", label: "Horário", help: "Ex: 14h às 18h" },
        { name: "location", label: "Local" },
        { name: "description", label: "Descrição", textarea: true, rows: 4 },
        { name: "image_url", label: "Imagem do evento", type: "image" },
        { name: "registration_link", label: "Link de inscrição" },
      ]}
      columns={[
        { name: "name", label: "Evento" },
        { name: "period", label: "Período", render: (r) => {
          const s = r.start_date || r.date;
          const e = r.end_date;
          if (!s) return "—";
          if (!e || e === s) return fmt(s);
          return `${fmt(s)} — ${fmt(e)}`;
        }},
        { name: "location", label: "Local" },
      ]}
    />
  );
}
